import { getShortsFeed } from "../../redux/action-creators/shortsAction";

export const SHORTS_PAGE_SIZE = 10;
export const SHORTS_WARM_AHEAD = 2;
const FEED_TTL_MS = 2 * 60_000;

type FeedResponse = any;

const prefetchedVideos = new Set<string>();
let feed: { res: FeedResponse; at: number } | null = null;
let inflight: Promise<FeedResponse | null> | null = null;

export const prefetchWebShortVideos = (urls: Array<string | undefined>) => {
  for (const url of urls) {
    if (!url || prefetchedVideos.has(url)) continue;
    prefetchedVideos.add(url);
    const link = document.createElement("link");
    link.rel = "preload";
    link.as = "video";
    link.href = url;
    document.head.appendChild(link);
  }
};

/** Fetch the default Shorts page ahead of time (called from the header on any signed-in page). */
export const prefetchWebShortsFeed = (): Promise<FeedResponse | null> => {
  if (feed && Date.now() - feed.at < FEED_TTL_MS) return Promise.resolve(feed.res);
  if (inflight) return inflight;
  inflight = getShortsFeed({ limit: SHORTS_PAGE_SIZE, sort: "chrono" })
    .then((res) => {
      if (!res?.isSuccess || !Array.isArray(res.data)) return null;
      feed = { res, at: Date.now() };
      const first = res.data.slice(0, SHORTS_WARM_AHEAD + 1);
      prefetchWebShortVideos(first.map((s: { videoUrl?: string }) => s.videoUrl));
      first.forEach((s: { thumbnailUrl?: string | null }) => {
        if (s.thumbnailUrl) new Image().src = s.thumbnailUrl;
      });
      return res;
    })
    .catch(() => null)
    .finally(() => {
      inflight = null;
    });
  return inflight;
};

/** Hand the prefetched page to Shorts once; the next visit fetches a fresh one. */
export const takeWebShortsFeed = async (): Promise<FeedResponse | null> => {
  const res = await prefetchWebShortsFeed();
  feed = null;
  return res;
};
